import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nPipe, ALAIN_I18N_TOKEN } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { finalize } from 'rxjs';
import { I18NService } from 'src/app/core/i18n/i18n.service';
import { HttpService } from 'src/app/http/http.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { ConstantUtil } from 'src/app/util/constant.util';

import { RobotServiceDetailComponent } from '../detail/robot-service-detail.component';

@Component({
  selector: 'robot-service-list',
  templateUrl: './robot-service-list.component.html',
  styleUrls: ['./robot-service-list.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    I18nPipe,
    NzToolTipModule,
    NzTableModule,
    NzTagModule,
    NzButtonModule,
    NzTabsModule,
    NzIconModule,
    NzSpinModule,
    TestIdDirective
  ]
})
export class RobotServiceListComponent implements OnInit {
  private readonly http = inject(HttpService);
  private readonly message = inject(NzMessageService);
  private readonly modalService = inject(NzModalService);
  private readonly modalRef = inject(NzModalRef, { optional: true });
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  nzModalData: any = inject(NZ_MODAL_DATA, { optional: true }) || {};

  selectedRobotId: string | null = null;
  @Output() readonly robotSelected = new EventEmitter<any>();

  // 列表数据
  robotList: any[] = [];
  loading = false;
  // 类型定义
  typeMap: Record<string, { label: string; color: string }> = {
    Gpt: { label: this.i18n.fanyi('robot-service.type.gpt'), color: 'purple' },
    Cbm: { label: this.i18n.fanyi('robot-service.type.cbm'), color: 'blue' },
    VirtualPersona: { label: this.i18n.fanyi('robot-service.identity.virtual-persona'), color: 'geekblue' },
    VirtualEmployee: { label: this.i18n.fanyi('robot-service.identity.virtual-employee'), color: 'cyan' }
  };

  // languageMap: Record<string, { label: string; color: string }> = {
  //   ZH_TW: { label: '繁体中文', color: 'green' },
  //   ZH_CN: { label: '简体中文', color: 'orange' },
  //   EN_US: { label: '英文', color: 'red' }
  // };

  ngOnInit(): void {
    this.selectedRobotId = this.nzModalData.robotServiceId;
    this.loadRobotList();
  }

  get isPageMode(): boolean {
    return !this.modalRef;
  }

  // 加载机器人列表
  loadRobotList(): void {
    this.loading = true;

    this.http
      .post(ConstantUtil.TENANT_ROBOT_SERVICE_LIST, {})
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: res => {
          if (res.success) {
            this.robotList = res.data || [];
            this.cdr.detectChanges();
          } else {
            this.message.error(res.msg ?? this.i18n.fanyi('robot-service.load-list-failed'));
          }
        },
        error: err => {
          this.message.error(this.i18n.fanyi('robot-service.load-list-failed'));
          console.error('Load robot service list error:', err);
        }
      });
  }

  // 获取类型显示信息
  getRobotTypeInfo(typeCode: string, identityType?: string): { label: string; color: string } {
    const preferred = identityType || typeCode;
    return this.typeMap[preferred] || { label: preferred, color: 'default' };
  }

  // getLanguageInfo(languageCode: string): { label: string; color: string } {
  //   return this.languageMap[languageCode] || { label: languageCode, color: 'default' };
  // }

  // 选择机器人
  selectRobot(robot: any): void {
    if (this.isPageMode) {
      return;
    }
    this.robotSelected.emit(robot);
    this.modalRef?.close(robot);
  }

  // 取消选择
  cancel(): void {
    this.modalRef?.close();
  }
  // 编辑机器人服务
  updateRobotService(event: MouseEvent, robot?: any): void {
    event.stopPropagation(); // 阻止事件冒泡，避免触发选择事件

    const modal = this.modalService.create({
      nzTitle: robot ? this.i18n.fanyi('robot-service.edit-title') : this.i18n.fanyi('robot-service.add-title'),
      nzContent: RobotServiceDetailComponent,
      nzWidth: '800px',
      nzFooter: null,
      nzBodyStyle: { padding: '0' },
      nzData: {
        robotId: robot?.id || null
      }
    });

    modal.afterClose.subscribe(result => {
      if (result) {
        this.loadRobotList();
      }
    });
  }
}
